import React from "react"
import cx from "classnames"

const getSizeCls = (size) => {
  switch (size) {
    case "xxs":
      return "w-[24px] h-[24px]"
    case "xs":
      return "w-[32px] h-[32px]"
    case "sm":
      return "w-[40px] h-[40px]"
    case "md":
      return "w-[60px] h-[60px]"
    case "lg":
      return "w-[96px] h-[96px]"
    case "xl":
      return "w-[120px] h-[120px]"
    default:
      return "w-[80px] h-[80px]"
  }
}

const Avatar = ({avatar, size = "md", className}) => <div className={cx(getSizeCls(size), className)}>{React.createElement(avatar.image)}</div>

export default Avatar